var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"box"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"price"},[_vm._v(_vm._s(_vm.price)+" "),_c('span',{staticStyle:{"font-size":"20px"}},[_vm._v(" "+_vm._s(_vm.unit))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }